import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { MenuItems } from './shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AuthGuard } from './guard/_guards/auth.guard';
import { VendorService } from './services/vendor.service';
import { ItemService } from './services/item.service';
import { CustomerService } from './services/customer.service';
import { WarehouseService } from './services/warehouse.service';
import { UserService } from './services/user.service';
import { InspctionService } from './services/inspection.service';
import { SettingService } from './services/setting.service';
import { StockItemService } from './services/stock-item.service';
import { ItemReceivedService } from './services/item-received.service';
import { AuthenService } from './services/authen.service';
import { MaterialReceiveService } from './services/material-receive.service';
import { InventoryService } from './services/inventory.service';
import { MasterService } from './services/master.service';
import { ItemCategoryService } from './services/itemcategory.service';
import { ShippingService } from './services/shipping.service';
import { ReportService } from './services/report';
import { SavefileService } from './services/savefile';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ClickOutsideModule } from 'ng-click-outside';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PermissionService } from './services/permission.service';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NotificationSettingService } from './services/notification-setting.service';
import { TimeService } from './services/time.service';
import { LotAcceptanceService } from './services/lot-acceptance.service';
import { DisposalService } from './services/disposal.service';
import { TransportationService } from './services/transportation.service';
import { ProductService } from './services/product.service';
import { QuotationService } from './services/quotation.service.';
import { HttpModule } from '@angular/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    BreadcrumbsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule ,
    AppRoutingModule,
    SharedModule,
    NgxTrimDirectiveModule,
    Ng4LoadingSpinnerModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      useDefaultLang: true
    }),
  ],
  providers: [MenuItems, TranslateService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AuthGuard,
    MenuItems
    , VendorService
    , ItemService
    , CustomerService
    , WarehouseService
    , UserService
    , InspctionService
    , SettingService
    , StockItemService
    , ItemReceivedService
    , AuthenService
    , MaterialReceiveService
    , InventoryService
    , MasterService
    , ItemCategoryService
    , ShippingService
    , ReportService
    , PermissionService
    , NotificationSettingService
    , TimeService
    , LotAcceptanceService
    , DisposalService
    , TransportationService
    , ProductService
    , QuotationService
    , SavefileService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts